<template>
	<section class="pt-60">
		<div class="container">
			<div class="row mt-4">
				<div class="col-md-12">
					<h1>WEBINAR</h1>
					<h2>The merits of Portable X-ray Diffractometers Fast processing and easy analysis</h2>
				</div>
			</div>
			<div class="row mb-5">
				<div id="about-content" class="col-md-6" contenteditable="false">
					<p>The mining and geology industries require increasingly agile responses in order to make timely and appropriate decisions.</p>
					<p>Therefore, we see a trend towards portable instruments that can be used directly in the field. Recently, X-ray diffraction on powders (XRPD) has been added to the portfolio of portable instrumentation. This enables you to obtain mineralogical data in the field. Based on a number of examples, the webinar provides insight in the merits of portable X-ray diffractometers.</p>
					<h3 class="text-center">
						Wednesday, March 18 2020
						<br />3:00 pm CET (9:00 am EST)
					</h3>
				</div>
				<div class="col-md-6">
					<p>Register via the folowing form:</p>
					<form>
						<div class="form-group row">
							<label for="inputName" class="col-md-3 col-form-label">Name</label>
							<div class="col">
								<input type="text" v-model="user.name" class="form-control" id="inputName" />
								<div class="text-danger" v-if="!$v.user.name.required">Field is required</div>
							</div>
						</div>
						<div class="form-group row">
							<label for="inputEmail" class="col-md-3 col-form-label">Email</label>
							<div class="col">
								<input type="email" v-model="user.email" class="form-control" id="inputEmail" />
								<div class="text-danger" v-if="!$v.user.email.required">Email address is required</div>
								<div class="text-danger" v-if="!$v.user.email.email">Correct email address is required</div>
							</div>
						</div>
						<b-button variant="outline-secondary" class="col" @click="register">Yes! I would like to register!</b-button>
					</form>

					<p class="mt-5">Or via the website of one of our sponsors:</p>
					<a href="https://www.electronet.com.ve/webinars" target="_blank">
						<img class="img-fluid" src="images/logo-electronet.png" />
					</a>
				</div>
			</div>

			<div class="row mb-5">
				<div class="col-md-8">
					<h2>About the presenter</h2>
					<p>Bert Kinneging spent a lifetime, studying, developing and applying X-ray diffraction. During his PhD study in the 1980s he developed a computer program for the determination of crystal structures from XRD data, which is still used world-wide.</p>
					<p>This was immediately followed by a six years period, where he worked on X-ray diffraction techniques for texture analysis for Philips research in Eindhoven.</p>
					<p>He worked for 14 years with Philips Analytical (nowadays known as Malvern PANalytical), where he supported the sales process and a large number of product developments with his expertise in XRD.</p>
					<p>Bert Kinneging conceived the portable, high-resolution diffractometer from xplorex.</p>
				</div>
				<div class="col">
					<img class="img-fluid p-3" src="images/webinar1.jpg" />
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';

import axios from 'axios';

export default {
	data: () => ({
		baseUrl: '/db-sqlite.php',
		user: {
			name: '',
			email: '',
			subject: 'webinar registration',
			to: 'bert.kinneging@xplorex.eu',
			from: 'noreply@xplorex.eu'
		},
		content: []
	}),

	validations: {
		user: {
			name: { required },
			email: { required, email }
		}
	},

	created() {
		// console.clear();
		axios
			.get(this.baseUrl + '/quark_table')
			.then(response => {
				this.content = response.data;
				for (var i = 0; i < this.content.length; i++) {
					//this.content[i].content = this.content[i].content.split('img-responsive').join('img-fluid');
					// this.content[i].content = this.content[i].content.replace(/<([^ >]+)[^>]*>/ig, '<$1>');
					// this.content[i].content = this.content[i].content.split('<table>').join('<table class="table  table-bordered">');
				}
				//console.log(this.content[0].content);
			})
			.catch(e => {
				// this.errors.push(e)
				console.log(e);
			});
	},

	methods: {
		quarkRead(section) {
			var content;
			for (var i = 0; i < this.content.length; i++) {
				if (this.content[i].section == section) {
					content = this.content[i].content;
					break;
				}
			}

			return content;
		},

		register() {
			this.$v.user.$touch();
			if (this.$v.user.$error) return;

			// send email
			axios
				.post('/sendmail.php', this.user)
				.then(result => {
					console.log(result);

					// show toast when mail sent
					this.$bvToast.toast('Thank you for registering!', {
						title: 'xplorex webinar',
						toaster: 'b-toaster-bottom-center',
						variant: 'success',
						autoHideDelay: 2000,
						hidden: this.hidden()
					});
				})
				.catch(error => {
					console.log(error);
				});
		},

		hidden() {
			this.user.name = '';
			this.user.email = '';
		}
	}
};
</script>